import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import { useSeo } from "../hooks/useSeo";

export default function NotFound() {
  const navigate = useNavigate();
  useSeo({
    title: "Page not found (404) | YogaToYacht",
    description: "Sorry, we couldn't find that page. Explore curated yoga, wellness, sailing and yacht retreats on YogaToYacht.",
    path: "/404",
    noindex: true,
  });

  return (
    <div data-testid="not-found-page" className="min-h-screen bg-brand-bg text-brand-ink">
      <Header onNavigate={() => navigate("/")} />
      <div className="mx-auto max-w-3xl px-6 pt-40 pb-24 text-center">
        <p className="overline text-brand-inkSoft">Error 404</p>
        <h1 className="font-display mt-3 text-5xl">This page wandered off</h1>
        <p className="mt-4 text-brand-inkSoft">
          The page you&apos;re looking for doesn&apos;t exist or may have moved. Let&apos;s get you back to the escapes.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-2 rounded-full bg-brand-ink px-6 py-3 text-sm font-medium text-white">
            Back to home
          </Link>
          <Link to="/escape/santorini-yoga" className="inline-flex items-center gap-2 rounded-full border border-brand-line px-6 py-3 text-sm font-medium text-brand-ink">
            Browse retreats
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
